import { render, staticRenderFns } from "./Layout-1.vue?vue&type=template&id=2aba80c4&scoped=true&"
import script from "./Layout-1.vue?vue&type=script&lang=js&"
export * from "./Layout-1.vue?vue&type=script&lang=js&"
import style0 from "./Layout-1.vue?vue&type=style&index=0&id=2aba80c4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba80c4",
  null
  
)

export default component.exports